//
// verification-code.js
//

class VerificationCodeInput {
  constructor(container, length = 6) {
    this.container = container;
    this.length = length;
    this.inputs = Array.from(this.container.querySelectorAll('input'));
    this.init();
  }

  init() {
    if (this.inputs.length !== this.length) {
      console.error(`Expected ${this.length} inputs, but found ${this.inputs.length}`);
    }

    this.inputs.forEach((input, i) => {
      input.maxLength = 1;
      input.inputMode = 'numeric';
      input.addEventListener('input', (e) => this.handleInput(e, i));
      input.addEventListener('keydown', (e) => this.handleKeydown(e, i));
      input.addEventListener('paste', (e) => this.handlePaste(e, i));
    });
  }

  handleInput(e, index) {
    const value = e.target.value.replace(/[^0-9]/g, '');
    e.target.value = value;
    if (value && index < this.length - 1) {
      this.inputs[index + 1].focus();
    }
  }

  handleKeydown(e, index) {
    if (e.key === 'Backspace' && !e.target.value && index > 0) {
      this.inputs[index - 1].focus();
    }
  }

  handlePaste(e, index) {
    e.preventDefault();
    const pasteData = e.clipboardData
      .getData('text')
      .replace(/[^0-9]/g, '')
      .slice(0, this.length);
    pasteData.split('').forEach((char, i) => {
      if (index + i < this.length) {
        this.inputs[index + i].value = char;
      }
    });
    this.inputs[Math.min(index + pasteData.length, this.length - 1)].focus();
  }

  getValue() {
    return this.inputs.map((input) => input.value).join('');
  }
}

const toggles = document.querySelectorAll('[data-toggle="verification-code"]');

toggles.forEach((container) => {
  const length = container.dataset.length ? parseInt(container.dataset.length, 10) : 6;
  new VerificationCodeInput(container, length, (code) => console.log('Code entered:', code));
});
